﻿let NewSessionCustomerData: any = null;
let ConfMgmtInitializationURLData: any = null;
let AllConnectRBMAs: any = {};
let AllConnectRevokeDelayCount: number = 12 * 60;
let AllConnectRevokeDelay: Date = new Date();
let AllConnectRevokeTimerVar: any;
let AllConnectRevokeTimerCount: number = 20 * 1000;
let AdminOrSpo: boolean = false;

const nscdi_Search: number = 0;
const nscdi_Bookmark: number = 1;
const nscdi_History: number = 2;
const nscdi_Search_edit: number = 3;
const nscdi_Bookmark_edit: number = 4;
const nscdi_History_edit: number = 5;
const nscdi_ConfMgmt_edit: number = 6;

namespace WebPortal.Navigation.Default {
    export class NavigationDefaultController extends WebPortal.Navigation.NavigationController implements WebPortal.Navigation.INavigationController {
        public collapse(withContentOffset: boolean) {
            super.collapse(withContentOffset);
            if (!LoginRequired && !!navigationHandler) { (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).ResizeDefaultTables(); }
        }
        public expand(withContentOffset: boolean) {
            super.expand(withContentOffset);
            if (!LoginRequired && !!navigationHandler) { (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).ResizeDefaultTables(); }
        }
        public pinNav() {
            super.pinNav();
        }
    }

    /***********************************************************************/
    export class NavigationDefaultHandler extends WebPortal.Navigation.NavigationHandler {
        private DefaultTour: WebPortal.WebPortalTour.Default.TourDefaultController = null;
        private infoMessage: string = "Here, no sensitive data such as usernames, passwords or other sensitive data may be noted down! Login information may only be written in the designated account fields.";

        constructor() {
            super();
            this.initNavigationDefaultHandler();
        }

        private initNavigationDefaultHandler() {
            // window resize
            $(window).resize(() => {
                this.ResizeDefaultTables();
            });

            // account Information laden (inkl. MySettings)
            new WebPortal.Dialog.Modal.AccountInformation();

            this.DefaultTour = new WebPortal.WebPortalTour.Default.TourDefaultController("DefaultTour");

            // configuration Management Handler setzen
            $("#navigation_lbt_configuration_management").off().on("click", () => {
                const requestParam = $("#hdf_se_request_param").val();
                if (!ConfMgmtInitializationURLData) {
                    Show_Status_Message({ title: "Configuration Management Initialization URL Preparation", message: "Loading Configuration Management Initialization URL Data", progress: true });
                    WebPortalHubObj.server.doConfMgmtInitializationURLListRequest(requestParam);
                } else {
                    this.PrepareConfMgmtInitializationURLModal(ConfMgmtInitializationURLData);
                    this.CheckSpoAndShowModal(requestParam)
                }
                return false;
            });

            // file Transfer Handler setzen
            $("#navigation_lbt_file_transfer").off().on("click", () => {
                return this.OpenTransferWindow();
            });

            // download AllConnect OpenVPN Zertifikat für Provider RBMA Zugriff Handler setzen
            $("#navigation_footer_lbt_download_allconnect_certificate").off().on("click", () => {
                this.PrepareAllConnectCertificateInfo();
                $("#pn_modal_download_allconnect_certificate").modal({ backdrop: "static", keyboard: false });
                return false;
            });

            // Delay AllConnect Certificate Revoke
            $("#bt_modal_download_allconnect_delay_revoke").off().on("click", () => {
                AllConnectRevokeDelay = moment(new Date()).add(AllConnectRevokeDelayCount, 'm').toDate();
                this.RefreshAllConnectRevokeView();
                return false;
            });

            // download RMS-Client Handler setzen
            $("#navigation_footer_lbt_download_client").off().on("click", () => {
                $.ajax({
                    type: 'GET',
                    url: $("#hdf_clientinfo").val(),
                    success: (data) => {
                        let clientData = jsyaml.load(data);
                        if (!!clientData) {
                            this.prepareDownloadClientInfo(clientData);
                        } else {
                            navigationMessage.show("DownloadClient", "Error, no Client-Release-Info.");
                        }
                        $("#pn_modal_download_client").modal({ backdrop: "static", keyboard: false });
                    },
                    error: (e) => {
                        console.error(e);
                        navigationMessage.show("DownloadClient", "Error to Load Client-Release-Info.");
                    }
                });

                return false;
            });

            $("#navigation_li_logoff").off().on("click", () => {
                let OpenWindows: Array<Window> = WebPortal.Misc.getOpenWindows();
                if (OpenWindows.length > 0) {
                    Show_Status_Message({ title: "RMS Log off Process", message: "Log off from RMS and close all Session Tabs?", progress: false, showAccept: true, acceptButtonName: "Log off", closeButtonName: "Cancel" });

                    $("#bt_modal_status_message_footer_accept").off().on("click", () => {
                        return this.CloseAllWindowAndLogoff();
                    }).on("keyup", (e: JQueryEventObject) => {
                        let ev: any = e || event;
                        if (ev.keyCode === 13) {
                            return this.CloseAllWindowAndLogoff();
                        }
                    });
                    return false;
                } else {
                    return this.CloseAllWindowAndLogoff();
                }
            });

            $("#bt_modal_detect_internetexplorer_accept").off().on("click", () => {
                $("#pn_modal_detect_internetexplorer").modal("hide");
                localStorage.setItem("IsInternetExplorerInfoAlreadyDisplayed", "true");
                return false;
            });
        }

        public CheckSpoAndShowModal(requestParam: any) {
            // API Query was removed -- the resource manager sends the config manager links only
            // if the user has the rights to open them
            Close_Status_Message();
            $("#pn_modal_confmgmtinitializationurls").modal({ backdrop: 'static', keyboard: false })
        }

        public SetOpenEditButton(cell: Node, cellData: any, rowData: any, row: number, col: number): void {
            let NewCellData: JQuery = $("<div/>").attr({
                "class": "btn-toolbar",
                "role": "toolbar",
                "style": "margin-top: -5px; margin-bottom: -5px;"
            });
            NewCellData.append(this.GetOpenCustomerButton());
            NewCellData.append(this.GetEditCustomerButton());

            $(cell).empty();
            $(cell).append(NewCellData);
        }

        public SetSecurityProperties(cell: Node, cellData: any, rowData: any, row: number, col: number): void {
            let NewCellData: JQuery = $("<div/>").attr({
                "class": "btn-toolbar",
                "role": "toolbar",
                "style": "margin-top: -5px; margin-bottom: -5px;"
            });
            if (!!rowData.W && rowData.W) {
                NewCellData.append(this.getMessageButton(rowData.W));
            }
            if (!!rowData.CH && rowData.CH) {
                NewCellData.append(this.getCHLocationButton());
            }
            if (!!rowData.PS && rowData.PS) {
                NewCellData.append(this.getProactiveSurveillanceButton());
            }

            let CellDataStr: String = new String(cellData);
            if (CellDataStr.search("DelBookmarkButton") > -1) {
                NewCellData.append(this.GetDeleteBookmarkButton(rowData.ID));
            }

            $(cell).empty();
            $(cell).append(NewCellData);
        }

        private getMessageButton(_Message: string): JQuery {
            return $("<button/>")
                .attr({
                    "title": this.getMessagePart(_Message),
                    "class": "btn btn-primary MessageActivated",
                    "style": "padding-bottom: 4px; padding-top: 4px; padding-right: 10px; padding-left: 10px;",
                    "data-message": _Message
                })
                .append(
                    $("<span/>")
                        .attr({
                            "title": this.getMessagePart(_Message),
                            "aria-hidden": "true",
                            "class": "glyphicon glyphicon-exclamation-sign MessageActivated",
                            "data-message": _Message
                        }));
        }

        private getMessagePart(_Message: string): string {
            let jdiv = document.createElement("div");
            jdiv.innerHTML = _Message;
            let blankText = jdiv.textContent;
            if (blankText.length > 17) {
                blankText = blankText.substr(0, 17) + "...";
            }
            return blankText;
        }

        private getCHLocationButton(): JQuery {
            let UserSettings = JSON.parse($("#hdf_settings").val());
            let ButtonClass: string = "btn-primary";
            if (!UserSettings || !UserSettings.Client2ndAuthLevel_ID || (UserSettings.Client2ndAuthLevel_ID != 4)) {
                ButtonClass = "btn-danger";
            }

            return $("<button/>")
                .attr({
                    "title": "Only CH-based access allowed",
                    "class": "btn " + ButtonClass + " CHLocationActivated",
                    "style": "padding-bottom: 4px; padding-top: 4px; padding-right: 10px; padding-left: 10px;",
                })
                .append(
                    $("<span/>")
                        .attr({
                            "title": "Only CH-based access allowed",
                            "aria-hidden": "true",
                            "class": "glyphicon glyphicon-map-marker CHLocationActivated",
                        }));
        }

        private getProactiveSurveillanceButton(): JQuery {
            return $("<button/>")
                .attr({
                    "title": "Proactive Surveillance required",
                    "class": "btn btn-primary ProactiveSurveillanceActivated",
                    "style": "padding-bottom: 4px; padding-top: 4px; padding-right: 10px; padding-left: 10px;",
                })
                .append(
                    $("<span/>")
                        .attr({
                            "title": "Proactive Surveillance required",
                            "aria-hidden": "true",
                            "class": "glyphicon glyphicon-eye-open ProactiveSurveillanceActivated",
                        }));
        }

        private GetOpenCustomerButton(): JQuery {
            return $("<button/>")
                .text("open")
                .attr({
                    "title": "Open Customer",
                    "type": "button",
                    "class": "btn btn-primary openCustomer",
                    "style": "padding-bottom: 4px; padding-top: 4px; padding-left: 10px;"
                });
        }

        private GetEditCustomerButton(): JQuery {
            return $("<button/>")
                .text("edit")
                .attr({
                    "title": "Edit Customer",
                    "type": "button",
                    "class": "btn btn-secondary editCustomer",
                    "style": "padding-bottom: 4px; padding-top: 4px; padding-right: 10px; padding-left: 10px;"
                });
        }

        private GetDeleteBookmarkButton(_Bookmark_ID): JQuery {
            return $("<button/>")
                .attr({
                    "title": "Delete Bookmark",
                    "class": "btn btn-danger removeBookmark",
                    "data-bookmark-id": _Bookmark_ID
                })
                .append(
                    $("<span/>")
                        .attr({
                            "title": "Delete Bookmark",
                            "aria-hidden": "true",
                            "class": "glyphicon glyphicon-trash removeBookmark",
                            "data-bookmark-id": _Bookmark_ID
                        }));
        }

        public ActiveSecurityProperties() {
            $(".MessageActivated").off().on("click", (e: JQueryEventObject) => {
                return this.OnMessageActivatedClicked(e);
            }).on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.OnMessageActivatedClicked(e);
                }
            });

            $(".CHLocationActivated").off().on("click", (e: JQueryEventObject) => {
                return this.OnCHLocationActivatedClicked(e);
            }).on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.OnCHLocationActivatedClicked(e);
                }
            });

            $(".ProactiveSurveillanceActivated").off().on("click", (e: JQueryEventObject) => {
                return this.OnProactiveSurveillanceActivatedClicked(e);
            }).on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.OnProactiveSurveillanceActivatedClicked(e);
                }
            });

            $(".removeBookmark").off().on("click", (e: JQueryEventObject) => {
                return this.OnRemoveBookmarkClicked(e);
            }).on("keyup", (e: JQueryEventObject) => {
                let ev: any = e || event;
                if (ev.keyCode === 13) {
                    return this.OnRemoveBookmarkClicked(e);
                }
            });
        }

        private OnMessageActivatedClicked(e: JQueryEventObject): boolean {
            //  console.info($(e.currentTarget).attr("data-message"));
            Show_Status_Message({ title: "Message", message: $(e.currentTarget).attr("data-message"), alertMessage: this.infoMessage });
            return false;
        }

        private OnCHLocationActivatedClicked(e: JQueryEventObject): boolean {
            //console.info($(e.currentTarget).text);
            this.doShowCHLocationMessage(false);
            return false;
        }

        private OnProactiveSurveillanceActivatedClicked(e: JQueryEventObject): boolean {
            //console.info($(e.currentTarget).text);
            let ProSurvMsg: string = '<p>  ' + //
                'Supplier/partner must be monitored proactively for this customer.<br />' + //
                'To do this, the "Session Sharing" feature is to be used to invite a supplier/partner to the private session.<br />' + //
                'For details, see the section on Session Sharing in the FAQ.<br />' + //
                'It shall be ensured proactively throughout the entire session time that the supplier/partner does not view, transfer or otherwise process any sensitive customer data without permission.' + //
                '</p>';

            Show_Status_Message({ title: "Proactive Surveillance required", message: ProSurvMsg });
            return false;
        }

        private OnRemoveBookmarkClicked(e: JQueryEventObject): boolean {
            let Bookmark_ID: number = +$(e.currentTarget).attr("data-bookmark-id");
            // IE unterstütz ID nicht, darum über Filter gelöst
            let ItemIndex: number = BookmarkData.Favorite.indexOf(BookmarkData.Favorite.filter(elem => elem.ID == Bookmark_ID)[0]);
            if (ItemIndex > -1) { BookmarkData.Favorite.splice(ItemIndex, 1); }
            WebPortalHubObj.server.doDeleteBookmarkRequest($("#hdf_se_request_param").val(), $(e.currentTarget).attr("data-bookmark-id"));
            $(e.currentTarget).closest("tr").remove();
            return false;
        }

        // Nur als Platzhalter, falls ein neuer Befehl zuerst geprüft werden soll
        public startChecksForLoadCustomer(): boolean {
            return this.checkIfInternetExplorerDetected();
        }

        public checkIfInternetExplorerDetected(): boolean {
            console.info("LoadCustomer - Check if Internet Explorer is detected");
            if (WebPortal.Misc.isInternetExplorerDetected()) {
                console.info("LoadCustomer - Internet Explorer is detected");
                $("#pn_modal_detect_internetexplorer").modal({ backdrop: "static", keyboard: false });

                $("#bt_modal_detect_internetexplorer_accept").off().on("click", () => {
                    $("#pn_modal_detect_internetexplorer").modal("hide");
                    return this.CheckCHLocationProperty();
                }).on("keyup", (e: JQueryEventObject) => {
                    let ev: any = e || event;
                    if (ev.keyCode === 13) {
                        $("#pn_modal_detect_internetexplorer").modal("hide");
                        return this.CheckCHLocationProperty();
                    }
                });

                return false;
            } else {
                return this.CheckCHLocationProperty();
            }
        }

        public CheckCHLocationProperty(): boolean {
            console.info("LoadCustomer - Check if CH Location is detected");
            if (!!NewSessionCustomerData.CH && NewSessionCustomerData.CH) {
                console.info("LoadCustomer - CH Location is detected");
                this.doShowCHLocationMessage(true);

                $("#bt_modal_status_message_footer_accept").off().on("click", () => {
                    return this.CheckMessageProperty();
                }).on("keyup", (e: JQueryEventObject) => {
                    let ev: any = e || event;
                    if (ev.keyCode === 13) {
                        return this.CheckMessageProperty();
                    }
                });

                return false;
            } else {
                return this.CheckMessageProperty();
            }
        }

        public CheckMessageProperty(): boolean {
            console.info("LoadCustomer - Check if Message is detected");
            if (!!NewSessionCustomerData.W && NewSessionCustomerData.W) {
                console.info("LoadCustomer - Message is detected");
                Show_Status_Message({ title: "Message", message: NewSessionCustomerData.W, alertMessage: this.infoMessage, showAccept: true, acceptButtonName: "OK", closeButtonName: "Cancel" });

                $("#bt_modal_status_message_footer_accept").off().on("click", (e: JQueryEventObject) => {
                    return this.LoadCustomer();
                }).on("keyup", (e: JQueryEventObject) => {
                    let ev: any = e || event;
                    if (ev.keyCode === 13) {
                        return this.LoadCustomer();
                    }
                });
                return false;
            } else {
                return this.LoadCustomer();
            }
        }

        private doShowCHLocationMessage(_ShowAccept: boolean = false) {
            let CHLocMsg: string = '<p>  ' + //
                'Remote access to this customer will be accepted only by persons residing in Switzerland. ' + //
                'To check this, Swisscom (Switzerland) AG will use the "Mobile ID" service to evaluate the country code and provider identifier of the mobile network you are using.<br /><br />' + //
                'By clicking "Accept" you authorize Swisscom to carry out this evaluation.<br /><br />' + //
                'And you confirm that you are personally residing in Switzerland for the entire duration of the remote connection and are not transferring customer-specific information abroad in any way (not Switzerland).' + //
                '</p>';

            let UserSettings = JSON.parse($("#hdf_settings").val());
            if (!UserSettings || !UserSettings.Client2ndAuthLevel_ID || (UserSettings.Client2ndAuthLevel_ID != 4)) {
                CHLocMsg = '<p><strong>' + //
                    'MobileID is not activated in your RMS setting. Please open "Account Information" over "Settings" and set "Second Authentication Method" to "MobileID".' + //
                    '</strong></p><hr />' + CHLocMsg;
                Show_Status_Message_Cause("Only CH-based access allowed", CHLocMsg, true);
            } else {
                if (_ShowAccept) {
                    Show_Status_Message({ title: "Only CH-based access allowed", message: CHLocMsg, showAccept: true, closeButtonName: "Cancel" });
                } else {
                    Show_Status_Message({ title: "Only CH-based access allowed", message: CHLocMsg });
                }
            }
        }

        public LoadCustomer(): boolean {
            if (!!NewSessionCustomerData) {
                let Customer_ID: number = NewSessionCustomerData.ID;
                let FilterInfoArr = [];
                let SearchList: any = $(".customer_search_field")
                    .each((index: number, elem: any) => {
                        let eInput: string = $(elem).val().trim().toLowerCase();
                        if (!!eInput) {
                            let fieldname: string = $(elem).attr("data-fieldname");
                            FilterInfoArr.push(
                                {
                                    "FilterName": fieldname,
                                    "SearchParam": eInput,
                                }
                            );
                        }
                    });
                let requestParam = $("#hdf_se_request_param").val();
                if (!!requestParam) {
                    Show_Status_Message({ title: "Session Preparation", message: "Initializing new Session in progress", progress: true });
                    console.info("Session - doInitializeSession");
                    WebPortalHubObj.server.doInitializeSession(requestParam, Customer_ID, NewSessionCustomerData.RequestType, FilterInfoArr);
                } else {
                    Show_Status_Message_Cause("Session Preparation", "Parameter Error - reload or restart Session", false);
                }
            } else {
                Show_Status_Message_Cause("Session Preparation", "Parameter Error - reload or restart Session", false);
            }
            return false;
        }

        public PrepareConfMgmtInitializationURLModal(_ConfMgmtInitializationURLData: any): void {
            if (!!_ConfMgmtInitializationURLData && !!_ConfMgmtInitializationURLData.ConfMgmtInitializationURLList) {
                ConfMgmtInitializationURLData = _ConfMgmtInitializationURLData;
                $("#pn_modal_confmgmtinitializationurl_area").empty();
                for (var itr = 0; itr < _ConfMgmtInitializationURLData.ConfMgmtInitializationURLList.length; itr++) {
                    let ConfMgmtInitializationURLObj = _ConfMgmtInitializationURLData.ConfMgmtInitializationURLList[itr];
                    $("#pn_modal_confmgmtinitializationurl_area")
                        .append(this.GetOpenConfMgmtItem(ConfMgmtInitializationURLObj.ConfMgmtInitializationURL_ID, ConfMgmtInitializationURLObj.Description));
                }

                $(".openConfMgmt").off().on("click", (e: JQueryEventObject) => {
                    return this.startChecksForConfMgmtInitialization(e);
                }).on("keyup", (e: JQueryEventObject) => {
                    let ev: any = e || event;
                    if (ev.keyCode === 13) {
                        return this.startChecksForConfMgmtInitialization(e);
                    }
                });
            }
        }

        private GetOpenConfMgmtItem(_ID: number, _Description: string): JQuery {
            return $("<tr>")
                .append($("<td>")
                    .attr({
                        "style": "vertical-align: middle",
                        "id": "confmgmtinitializationurl" + _ID
                    })
                    .append(
                        $("<button/>")
                            .text("open")
                            .attr({
                                "title": "Open " + _Description,
                                "type": "button",
                                "class": "btn btn-primary openConfMgmt",
                                "data-confmgmtinitializationurl-id": _ID
                            })
                    ))
                .append($("<td>")
                    .attr({
                        "style": "vertical-align: middle"
                    })
                    .text(_Description)
                )
        }

        // Nur als Platzhalter, falls ein neuer Befehl zuerst geprüft werden soll
        public startChecksForConfMgmtInitialization(e: JQueryEventObject): boolean {
            $("#pn_modal_confmgmtinitializationurls").modal("hide");
            let ConfMgmtInitializationURL_ID: number = +$(e.currentTarget).attr("data-confmgmtinitializationurl-id");
            return this.checkConfMgmtIfInternetExplorerDetected(ConfMgmtInitializationURL_ID);
        }

        public checkConfMgmtIfInternetExplorerDetected(_ConfMgmtInitializationURL_ID: number): boolean {
            console.info("ConfMgmtInitialization - Check if Internet Explorer is detected");
            if (WebPortal.Misc.isInternetExplorerDetected()) {
                console.info("ConfMgmtInitialization - Internet Explorer is detected");
                $("#pn_modal_detect_internetexplorer").modal({ backdrop: "static", keyboard: false });

                $("#bt_modal_detect_internetexplorer_accept").off().on("click", () => {
                    $("#pn_modal_detect_internetexplorer").modal("hide");
                    return this.OnConfMgmtInitializationURLClicked(_ConfMgmtInitializationURL_ID);
                }).on("keyup", (e: JQueryEventObject) => {
                    let ev: any = e || event;
                    if (ev.keyCode === 13) {
                        $("#pn_modal_detect_internetexplorer").modal("hide");
                        return this.OnConfMgmtInitializationURLClicked(_ConfMgmtInitializationURL_ID);
                    }
                });

                return false;
            } else {
                return this.OnConfMgmtInitializationURLClicked(_ConfMgmtInitializationURL_ID);
            }
        }

        private OnConfMgmtInitializationURLClicked(_ConfMgmtInitializationURL_ID: number): boolean {
            let requestParam = $("#hdf_se_request_param").val();
            if (!!requestParam) {
                Show_Status_Message({ title: "Configuration Management Session Preparation", message: "Initializing new Session for Configuration Management in progress", progress: true });

                console.info("Session - doInitializeConfMgmtSession");
                WebPortalHubObj.server.doInitializeSession(requestParam, _ConfMgmtInitializationURL_ID, nscdi_ConfMgmt_edit);
            } else {
                Show_Status_Message_Cause("Configuration Management Session Preparation", "Parameter Error - reload or restart Session", false);
            }
            return false;
        }

        /***********************************************************************/
        /*              Transfer Window öffnen oder anzeigen                   */
        /***********************************************************************/

        public OpenTransferWindow() {
            let OpenWindows: Array<Window> = WebPortal.Misc.getOpenWindows();
            let TransferWindow: Window = null;
            for (var itr = 0; itr < OpenWindows.length; itr++) {
                try {
                    let WindowStatus: string = "";
                    try {
                        WindowStatus = OpenWindows[itr].location.toString();
                    } catch{ }

                    if ((WindowStatus.search(TransferIdentifier) != -1) && !OpenWindows[itr].closed) {
                        console.info("Found Transferwindow, show - WindowStatus: " + WindowStatus);
                        TransferWindow = OpenWindows[itr];
                        break;
                    }
                } catch { };
            }

            if (!!TransferWindow) {
                if (Misc.isRmsClient()) {
                    const rmsWindow: any = window;
                    const ipcRenderer = rmsWindow.rms.ipcRenderer;
                    ipcRenderer.send('rms-win-focus', TransferIdentifier);
                } else {
                    TransferWindow.focus();
                }
                navigationMessage.show("FileTransfer", "FileTransfer Window already open (if nothing happens, maybe the window can't focus).");
            } else {
                console.info("Open Transferwindow");
                WebPortal.openWindow(window.location.protocol + "//" + window.location.host + "/" + TransferIdentifier);
            }
            return false;
        }


        /***********************************************************************/
        /*                  Client Download Info anzeigen                      */
        /***********************************************************************/

        public prepareDownloadClientInfo(_Data: any): void {
            //  console.info(JSON.stringify(_Data));
            let clientReleaseNotes: string = _Data.releaseNotes;
            clientReleaseNotes = clientReleaseNotes.replace(/- /g, "<br />- ")
            clientReleaseNotes = clientReleaseNotes.replace("<br />", "")
            $("#pn_modal_download_client_area").empty();
            $("#pn_modal_download_client_area")
                .append(this.getClientInfoTableEntry("Version", _Data.version))
                .append(this.getClientInfoTableEntry("Size", Misc.formatFileSize(_Data.files[0].size)))
                .append(this.getClientInfoTableEntry("Release Date", moment(_Data.releaseDate).format("DD.MM.YYYY HH:mm:ss")))
                .append(this.getClientInfoTableEntry("Release Notes", clientReleaseNotes))
                .append(this.getDownloadClientButton(_Data.files[0].url, _Data.path))
        }

        private getClientInfoTableEntry(_Description: string, _Value: string): JQuery {
            return $("<tr>")
                .append($("<td>")
                    .text(_Description)
                )
                .append($("<td>")
                    .html(_Value)
                )
        }

        private getDownloadClientButton(ExeURL: string, FileName: string): JQuery {
            return $("<tr>")
                .append($("<td>")
                )
                .append($("<td>")
                    .append(
                        $("<button/>")
                            .text("Download " + FileName)
                            .attr({
                                "title": FileName,
                                "type": "button",
                                "class": "btn btn-primary",
                                "style": "padding-bottom: 4px; padding-top: 4px; padding-right: 10px; padding-left: 10px;"
                            }).click(() => {
                                setTimeout(() => { window.open(ExeURL, "_blank"); }, 500);
                                return false;
                            })
                    )
                )
        }

        /***********************************************************************/
        /*                      Default Timer überprüfen                       */
        /***********************************************************************/

        public checkWorkingStateTimer() {
            let MinutesBetweenLastActivity = (new Date().getTime() - LastActivity.getTime()) / (1000 * 60);
            console.debug("checkWorkingStateTimer: UnLoad if LastActivity: " + MinutesBetweenLastActivity.toFixed(3) + " > WorkingStateTimer: " + CloseTimer_Transfer_inMin);
            if (MinutesBetweenLastActivity > CloseTimer_Default_inMin) {
                let OpenWindows: Array<Window> = WebPortal.Misc.getOpenWindows();
                let canUnload: boolean = true;
                for (var itr = 0; itr < OpenWindows.length; itr++) {
                    try {
                        let WindowStatus: string = "";
                        try {
                            WindowStatus = OpenWindows[itr].status;
                        } catch{ }

                        if ((Misc.isRmsClient && !OpenWindows[itr].closed) || ((WindowStatus.search(PortalIdentifier) != -1) && !OpenWindows[itr].closed)) {
                            console.info("Found Childwindow, can not close Window - WindowStatus: " + WindowStatus);
                            canUnload = false;
                        }
                    } catch { };
                }

                if (this.HasActiveAllConnectSession()) {
                    console.info("Found AllConnect connection, can not close Window");
                    canUnload = false;
                }

                if (canUnload) {
                    clearInterval(AllConnectRevokeTimerVar);
                    ActualPage.PageUnLoad();
                    setTimeout(() => {
                        Show_Status_Message_Cause("Session activity check", "Session expired. Please restart for future work.");
                    }, 500);
                    close();
                }
            }
        }

        /***********************************************************************/
        /*           AllConnect Modal mit AccessGroup initialisieren           */
        /***********************************************************************/

        private HasActiveAllConnectSession(): boolean {
            let now = moment(new Date());
            let duration = moment.duration(moment(AllConnectRevokeDelay).diff(now));
            return (($("#pn_modal_download_allconnect_certificate").data('bs.modal') || {}).isShown === true) && !$("#bt_modal_download_allconnect_delay_revoke").prop("disabled") && (duration.asMinutes() > 0);
        }

        public PrepareAllConnectCertificateInfo(): void {
            if ($("#bt_modal_download_allconnect_delay_revoke").prop("disabled")) {
                $("#pn_modal_download_allconnect_certificate_area").empty();
                let UserSettings = JSON.parse($("#hdf_settings").val());
                if (!!UserSettings && !!UserSettings.AllConnectAccessGroups && (UserSettings.AllConnectAccessGroups.length > 0)) {
                    console.info("AllConnectAccessGroups");
                    for (var itr = 0; itr < UserSettings.AllConnectAccessGroups.length; itr++) {
                        console.info(UserSettings.AllConnectAccessGroups[itr]);

                        let AllconnectCertificateArea: JQuery = $("<tr>");
                        AllconnectCertificateArea.append(this.getAllConnectSpinner(UserSettings.AllConnectAccessGroups[itr]));
                        AllconnectCertificateArea.append(this.getAllConnectPrepareOpenVPNCertificationDownloadButton(UserSettings.AllConnectAccessGroups[itr]));
                        if (!!UserSettings && UserSettings.IsSwisscomUser) {
                            AllconnectCertificateArea.append(this.getAllConnectPrepareOpenVPNCertificationDownloadWithProxyButton(UserSettings.AllConnectAccessGroups[itr]));
                        }
                        AllconnectCertificateArea.append(this.getAllConnectOpenRIMSPortalButton(UserSettings.AllConnectAccessGroups[itr]));
                        AllconnectCertificateArea.append(this.getAllConnectOpenAccessGroupDesc(UserSettings.AllConnectAccessGroups[itr]));
                        $("#pn_modal_download_allconnect_certificate_area").append(AllconnectCertificateArea);
                    }
                }
            }
        }

        private getAllConnectSpinner(AccessGroup: string): JQuery {
            return $("<td>")
                .attr({
                    "style": "vertical-align: middle"
                })
                .append(
                    $("<div/>")
                        .attr({
                            "id": "loading_pinner_" + AccessGroup,
                            "class": "loading_spinner hidden"
                        })
                )
        }

        private getAllConnectPrepareOpenVPNCertificationDownloadButton(AccessGroup: string): JQuery {
            return $("<td>")
                .attr({
                    "style": "vertical-align: middle"
                })
                .append(
                    $("<button/>")
                        .text("get Certificate")
                        .attr({
                            "id": "bt_generateOVCert_" + AccessGroup,
                            "title": "Generate OpenVPN Certificate for " + AccessGroup,
                            "type": "button",
                            "class": "btn btn-primary"
                        }).click(() => {
                            return this.PrepareOpenVPNCertificationDownload(AccessGroup, false);
                        })
                )
        }

        private getAllConnectPrepareOpenVPNCertificationDownloadWithProxyButton(AccessGroup: string): JQuery {
            return $("<td>")
                .attr({
                    "style": "vertical-align: middle"
                })
                .append(
                    $("<button/>")
                        .text("get with Proxy")
                        .attr({
                            "id": "bt_generateOVPCert_" + AccessGroup,
                            "title": "Generate OpenVPN Certificate with Swisscom Proxy for " + AccessGroup,
                            "type": "button",
                            "class": "btn btn-primary"
                        }).click(() => {
                            return this.PrepareOpenVPNCertificationDownload(AccessGroup, true);
                        })
                )
        }

        private getAllConnectOpenRIMSPortalButton(AccessGroup: string): JQuery {
            return $("<td>")
                .attr({
                    "style": "vertical-align: middle"
                })
                .append(
                    $("<button/>")
                        .text("open Portal")
                        .attr({
                            "id": "bt_openPortal_" + AccessGroup,
                            "title": "Open Portal for " + AccessGroup,
                            "type": "button",
                            "class": "btn btn-secondary"
                        }).prop({
                            "disabled": true
                        }).click(
                            () => { return this.OpenRIMSPortal(AccessGroup); })
                );
        }

        private getAllConnectOpenAccessGroupDesc(AccessGroup: string): JQuery {
            return $("<td>")
                .attr({
                    "style": "vertical-align: middle"
                })
                .text(AccessGroup + " RBMA");
        }

        private PrepareOpenVPNCertificationDownload(_AccessGroup: string, _WithProxy): boolean {
            let requestParam = $("#hdf_se_request_param").val();

            if (!!requestParam) {
                let RMBA: string = _AccessGroup.replace(AllConnectAccessGroupPattern, "").toLowerCase();

                //let TempCertInfo = AllConnectRBMAs[_AccessGroup];
                //if (TempCertInfo == null) {
                $("#bt_generateOVCert_" + _AccessGroup).prop("disabled", true);
                $("#bt_generateOVPCert_" + _AccessGroup).prop("disabled", true);
                $("#loading_pinner_" + _AccessGroup).removeClass("hidden");
                WebPortalHubObj.server.doAllConnectCreateOpenVPNCertificate(requestParam, RMBA, _WithProxy).done((_CertInfo) => {
                    AllConnectRBMAs[_AccessGroup] = _CertInfo;
                    $("#loading_pinner_" + _AccessGroup).addClass("hidden");
                    $("#bt_generateOVCert_" + _AccessGroup).prop("disabled", false);
                    $("#bt_generateOVPCert_" + _AccessGroup).prop("disabled", false);
                    $("#bt_openPortal_" + _AccessGroup).prop("disabled", false);
                    $("#bt_openPortal_" + _AccessGroup).addClass("btn-success");
                    if (_CertInfo) {
                        this.InitOpenVPNCertificationDownload(_AccessGroup, _CertInfo);
                    } else {
                        Show_Status_Message_Cause("Generate Certificate Error", "Error to generate Certificate for AllConnect", true);
                    }
                });

                $("#bt_modal_download_allconnect_delay_revoke").prop("disabled", false);
                AllConnectRevokeDelay = moment(new Date()).add(AllConnectRevokeDelayCount, 'm').toDate();
                console.info("AllConnectRevokeTimerVar - start Intervall");
                AllConnectRevokeTimerVar = setInterval(() => this.onAllConnectRevokeTimer(), AllConnectRevokeTimerCount);
                // } else {
                //this.InitOpenVPNCertificationDownload(_AccessGroup, TempCertInfo);
                //}
            } else {
                Show_Status_Message_Cause("Generate OpenVPN Certificate", "Parameter Error - reload or restart Session", false);
            }

            return false;
        }

        private InitOpenVPNCertificationDownload(_AccessGroup: string, _CertInfo: any): void {
            var blob = new Blob([_CertInfo.certificate]);
            let anchor = document.createElement('a');

            anchor.download = _AccessGroup + ".ovpn";
            anchor.href = URL.createObjectURL(blob);
            anchor.dataset.downloadurl = [anchor.download, anchor.href].join(':');
            anchor.click();
        }

        private OpenRIMSPortal(_AccessGroup: string): void {
            let RMBA: string = _AccessGroup.replace(AllConnectAccessGroupPattern, "").toLowerCase();
            let TempCertInfo = AllConnectRBMAs[_AccessGroup];
            if (TempCertInfo != null) {
                setTimeout(() => { window.open("https://" + TempCertInfo.dk_host_ip, "_blank"); }, 500);
            } else {
                Show_Status_Message_Cause("Open RIMS Portal", "Parameter Error - reload or restart Session and certificate request", false);
            }
        }

        private onAllConnectRevokeTimer(): void {
            let now = moment(new Date());
            let duration = moment.duration(moment(AllConnectRevokeDelay).diff(now));
            if (duration.asMinutes() > 0) {
                this.RefreshAllConnectRevokeView();
            } else {
                console.info("AllConnectRevokeTimerVar - clear Interval");
                clearInterval(AllConnectRevokeTimerVar);
                AllConnectRevokeDelay = new Date();
            }
        }

        private RefreshAllConnectRevokeView(): void {
            let now = moment(new Date());
            let duration = moment.duration(moment(AllConnectRevokeDelay).diff(now));
            let hours = Math.floor(duration.asHours());
            let mins = Math.floor(duration.asMinutes()) - hours * 60;
            $("#lb_modal_download_allconnect_delay_revoke").text(hours + "h " + mins + "min");
        }

        /***********************************************************************/
        /*     Warn Popup anzeigen wenn Internet Explorer festgestellt wird    */
        /***********************************************************************/

        public showModalIfInternetExplorerDetected() {
            let IsInternetExplorerInfoAlreadyDisplayed: string = localStorage.getItem("IsInternetExplorerInfoAlreadyDisplayed");
            if (!IsInternetExplorerInfoAlreadyDisplayed) {
                if (WebPortal.Misc.isInternetExplorerDetected()) {
                    console.info("Show Warning, Internet Explorer is detected");
                    $("#pn_modal_detect_internetexplorer").modal({ backdrop: "static", keyboard: false });
                }
            }
        }

        /***********************************************************************/
        /*                   Tour Informationen setzen                         */
        /***********************************************************************/
        public StartTour(): void {
            this.DefaultTour.start();
        }

        public RestartTour(): void {
            this.DefaultTour.restart();
        }

        public ResizeDefaultTables(): void {
            if ($("#li_customersearch").hasClass("active")) {
                Default_CustomerSearch_Handler.resize();
            }
            if ($("#body_li_bookmark").hasClass("active")) {
                Default_Bookmark_Handler.resize();
            }
            if ($("#body_li_history").hasClass("active")) {
                Default_History_Handler.resize();
            }
            if ($("#body_li_faq").hasClass("active")) {
                Default_FAQ_Handler.resize();
            }
            if ($("#body_li_changelog").hasClass("active")) {
                Default_ChangeLog_Handler.resize();
            }
        }
    }
}
